import {
  Box,
  Button,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  HStack,
  Input,
  InputGroup,
  InputLeftElement,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Select,
  Text,
  useToast,
} from "@chakra-ui/react";
import { partial } from "filesize";
import { useFormik } from "formik";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useDropzone } from "react-dropzone";
import { MdMailOutline } from "react-icons/md";
import SponsorService from "../../../services/admin/sponsors.service";

export const NewSponsorModal: React.FC<any> = ({
  isOpen,
  onClosed,
  isSponsor = false,
  reload,
  isBatch,
}: {
  isSponsor: boolean;
  isOpen: any;
  onClosed: any;
  reload: any;
  isBatch: boolean;
}) => {
  const toast = useToast();
  const cancelRef = useRef().current;
  const inputRef = useRef<HTMLInputElement | null>(null);

  const [sponsorType, setSponsorType] = useState<any>([]);
  const [sponsorMails, setsponsorMails] = useState<any>([]);
  const [logoFile, setlogoFile] = useState<File | null>(null);
  const [batchFile, setbatchFile] = useState<FormData | null>(null);
  const [filename, setFilename] = useState("");
  const [uploadFileSize, setUploadFileSize] = useState("");
  const [preview, setPreview] = useState<string | undefined>();

  // create a preview as a side effect, whenever selected file is changed
  useEffect(() => {
    if (!logoFile) {
      setPreview(undefined);
      return;
    }

    const objectUrl = URL.createObjectURL(logoFile);
    setPreview(objectUrl);

    // free memory when ever this component is unmounted
    return () => URL.revokeObjectURL(objectUrl);
  }, [batchFile]);

  const baseStyle = {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "30px",
    borderWidth: 2,
    borderRadius: 2,
    borderColor: "#eeeeee",
    borderStyle: "dashed",
    backgroundColor: "#fafafa",
    color: "#bdbdbd",
    outline: "none",
    transition: "border .24s ease-in-out",
  };

  const activeStyle = {
    borderColor: "#2196f3",
  };

  const acceptStyle = {
    borderColor: "#00e676",
  };

  const rejectStyle = {
    borderColor: "#ff1744",
  };

  const onDrop = useCallback((acceptedFiles: File[]) => {
    if (!acceptedFiles.length) {
      toast({
        title: "File Upload",
        description: "Invalid file uploaded",
        status: "error",
      });
      setbatchFile(null);
    } else {
      const formData = new FormData();
      const file = acceptedFiles[0];

      formData.append("sponsors", file);
      setbatchFile(formData);
      setFilename(file.name);
      toast({
        title: "File Upload",
        description: "Your file is ready for upload",
        status: "success",
      });
    }
  }, []);

  const {
    getRootProps,
    getInputProps,
    isDragActive,
    isDragAccept,
    isDragReject,
  } = useDropzone({ onDrop });
  const style = useMemo(
    () => ({
      ...baseStyle,
      ...(isDragActive ? activeStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {}),
    }),
    [isDragActive, isDragReject, isDragAccept]
  );

  const sponsorTypes = [
    {
      id: 1,
      name: "private",
    },
    {
      id: 2,
      name: "public",
    },
    {
      id: 3,
      name: "individual",
    },
  ];

  useEffect(() => {
    setSponsorType(sponsorTypes);
  }, []);

  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    if (value) {
      const fileName = e.target.files?.item(0)?.name as string;

      const fileType = e.target.files?.item(0)?.type;
      const file = e.target.files?.item(0) as File;

      if (fileType?.split("/").at(0) !== "image") {
        // formik.setErrors({ certificate: 'Only PDF,jpg,png file format is supported' });
        return;
      }
      setFilename(fileName);
      setlogoFile(file);
      const fileSize = partial({ base: 2, standard: "jedec" });
      setUploadFileSize(fileSize(file.size));
    } else {
      setFilename("");
      setlogoFile(null);
    }
    formik.handleChange(e);
  };

  const formik = useFormik({
    validate: (values: any) => {
      const errors: any = {};
      if (!values.sponsorName) {
        errors.sponsorName = "Sponsor  Name is required";
      }
      if (!values.sponsorMail) {
        errors.sponsorMail = "Sponsor Email  is required";
      }
      if (!values.sponsorType) {
        errors.sponsorType = "Sponsor type is required";
      }
      if (!values.address) {
        errors.address = "Sponsor address is required";
      }

      if (!values.phone) {
        errors.phone = "Sponsor Phone number is required";
      }

      if (!values.website) {
        errors.website = "Sponsor website is required";
      }

      return errors;
    },
    initialValues: {
      sponsorName: "",
      sponsorMail: "",
      sponsorType: "",
      address: "",
      phone: "",
      website: "",
    },
    onSubmit: async (values) => {
      try {
        if (logoFile) {
          const formDataa = new FormData();
          const file = logoFile;
          formDataa.append("logo", file);
          formDataa.append("organization_name", values.sponsorName);
          formDataa.append("type", values.sponsorType);
          formDataa.append("address", values.address);
          formDataa.append("phone", values.phone.toString());
          formDataa.append("email", values.sponsorMail);
          formDataa.append("website", values.website);

          const createSponsor = await SponsorService.createSponsor(formDataa);

          //trying something

          if (createSponsor) {
            toast({
              title: "Sponsor Management",
              description: "sponsor created successfully",
              status: "success",
              duration: 2000,
              onCloseComplete: () => onClosed(),
            });
            reload();
          }
        } else {
          const formDataa = new FormData();
          formDataa.append("organization_name", values.sponsorName);
          formDataa.append("type", values.sponsorType);
          formDataa.append("address", values.address);
          formDataa.append("phone", values.phone.toString());
          formDataa.append("email", values.sponsorMail);
          formDataa.append("website", values.website);

          const createSponsor = await SponsorService.createSponsor(formDataa);

          //trying something

          if (createSponsor) {
            toast({
              title: "Sponsor Management",
              description: "sponsor created successfully",
              status: "success",
              duration: 2000,
              onCloseComplete: () => onClosed(),
            });
            reload();
          }
        }
      } catch (error: any) {
        toast({
          title: "Sponsor Management",
          description: `${error.response.data.message}`,
          status: "error",
        });
      }
    },
  });

  const submitFile = () => {
    if (batchFile) {
      SponsorService.batchUploadSponsor(batchFile)
        .then((res) => {
          toast({
            title: "Batch Upload",
            description: "Sponsors uploaded successfully",
            status: "success",
            duration: 2000,
          });
          reload();
          onClosed();
        })
        .catch((err) => {
          toast({
            title: "Batch Upload",
            description: `${err.response.data.message}`,
            status: "error",
            duration: 2000,
          });
        });
    } else {
      toast({
        title: "File Upload",
        description: "Please select a file to upload",
        status: "error",
      });
    }
  };

  return (
    <>
      <Modal
        isOpen={isOpen && isSponsor}
        onClose={onClosed}
        scrollBehavior="outside"
        closeOnOverlayClick={true}
        size="md"
      >
        <ModalOverlay />
        <ModalContent borderRadius={5}>
          <ModalHeader>
            {
              <Text
                fontSize="22px"
                fontWeight="700"
                textTransform="none"
                color="#2B2B2B"
              >
                {isBatch ? "Bulk Upload Sponsor(s)" : "Add New Sponsor"}
              </Text>
            }
          </ModalHeader>
          <ModalCloseButton size="md" />
          <ModalBody>
            <Box mt={2}>
              {isBatch ? (
                <Box>
                  <form>
                    <FormLabel fontWeight="700" color="#757575" fontSize="14px">
                      Upload Sponsors
                    </FormLabel>
                    <div {...getRootProps({ style })}>
                      <input {...getInputProps()} />
                      {isDragActive ? (
                        <p>Drop the files here ...</p>
                      ) : (
                        <p>
                          Drag and drop or browse file <br /> Only Excel(.xsl)
                          files allowed{" "}
                        </p>
                      )}
                    </div>

                    <Flex mt={12} justifyContent="end">
                      <HStack>
                        <Button
                          size="sm"
                          px={6}
                          fontSize={12}
                          ref={cancelRef}
                          onClick={() => onClosed()}
                        >
                          Cancel
                        </Button>
                        <Button
                          colorScheme="red"
                          size="sm"
                          px={6}
                          onClick={() => {
                            submitFile();
                          }}
                          fontSize={12}
                        >
                          {" "}
                          Save
                        </Button>
                      </HStack>
                    </Flex>
                  </form>
                </Box>
              ) : (
                <form onSubmit={formik.handleSubmit}>
                  <FormControl
                    isInvalid={
                      formik.errors.sponsorName && formik.touched.sponsorName
                        ? true
                        : false
                    }
                  >
                    <FormLabel fontWeight="700" color="#757575" fontSize="14px">
                      Sponsor Name
                    </FormLabel>
                    <Input
                      type="text"
                      id="sponsorName"
                      name="sponsorName"
                      placeholder="Enter sponsor name"
                      onChange={formik.handleChange}
                      fontSize={13}
                    />

                    <FormErrorMessage fontSize={12}>
                      {formik.errors.sponsorName}
                    </FormErrorMessage>
                  </FormControl>
                  <FormControl
                    mt={4}
                    isInvalid={
                      formik.errors.sponsorMail && formik.touched.sponsorMail
                        ? true
                        : false
                    }
                  >
                    <FormLabel fontWeight="700" color="#757575" fontSize="14px">
                      Sponsor Email{" "}
                    </FormLabel>
                    <InputGroup>
                      <InputLeftElement
                        color="brand.subtitle"
                        pointerEvents="none"
                        children={<MdMailOutline />}
                      />
                      <Input
                        type="email"
                        id="sponsorMail"
                        name="sponsorMail"
                        placeholder="Enter email"
                        onChange={formik.handleChange}
                        fontSize={13}
                      />
                    </InputGroup>
                    <FormErrorMessage fontSize={12}>
                      {formik.errors.sponsorMail}{" "}
                    </FormErrorMessage>
                  </FormControl>
                  <FormControl
                    mt={4}
                    isInvalid={
                      formik.errors.sponsorType && formik.touched.sponsorType
                        ? true
                        : false
                    }
                  >
                    <FormLabel fontWeight="700" color="#757575" fontSize="14px">
                      Sponsor Type
                    </FormLabel>
                    <Select
                      variant="outline"
                      bg="inputText.500"
                      size="md"
                      placeholder="Select type"
                      value={formik.values.sponsorType}
                      name="sponsorType"
                      onChange={formik.handleChange}
                      fontSize={13}
                      color="brand.subtitle"
                    >
                      {sponsorType.map((each: any) => (
                        <option key={each.id} value={each.name}>
                          {" "}
                          {each.name}{" "}
                        </option>
                      ))}
                    </Select>
                    <FormErrorMessage fontSize={12}>
                      {formik.errors.sponsorType}
                    </FormErrorMessage>
                  </FormControl>
                  <FormControl
                    mt={4}
                    isInvalid={
                      formik.errors.website && formik.touched.website
                        ? true
                        : false
                    }
                  >
                    <FormLabel fontWeight="700" color="#757575" fontSize="14px">
                      Sponsors Website
                    </FormLabel>
                    <Input
                      type="text"
                      id="website"
                      name="website"
                      placeholder="Enter website address"
                      onChange={formik.handleChange}
                      fontSize={13}
                    />

                    <FormErrorMessage fontSize={12}>
                      {formik.errors.website}
                    </FormErrorMessage>
                  </FormControl>
                  <FormControl
                    mt={4}
                    isInvalid={
                      formik.errors.address && formik.touched.address
                        ? true
                        : false
                    }
                  >
                    <FormLabel fontWeight="700" color="#757575" fontSize="14px">
                      Address
                    </FormLabel>
                    <Input
                      type="text"
                      id="address"
                      name="address"
                      placeholder="Enter sponsor address"
                      onChange={formik.handleChange}
                      fontSize={13}
                    />

                    <FormErrorMessage fontSize={12}>
                      {formik.errors.address}
                    </FormErrorMessage>
                  </FormControl>
                  <FormControl
                    mt={4}
                    isInvalid={
                      formik.errors.phone && formik.touched.phone ? true : false
                    }
                  >
                    <FormLabel fontWeight="700" color="#757575" fontSize="14px">
                      Phone Number
                    </FormLabel>
                    <Input
                      type="number"
                      id="phone"
                      name="phone"
                      placeholder="Enter phone number"
                      onChange={formik.handleChange}
                      fontSize={13}
                    />
                    <FormErrorMessage fontSize={12}>
                      {formik.errors.phone}
                    </FormErrorMessage>
                  </FormControl>

                  {filename && (
                    <Box height={"70px"} width={"100px"} mt="10px" mb="10px">
                      <img src={preview} />
                    </Box>
                  )}
                  <FormControl mr={10} mt={4}>
                    <FormLabel fontWeight="600" color="#757575" fontSize={14}>
                      Upload Logo
                    </FormLabel>
                    <Text fontWeight="400" color="#959595" fontSize="14px">
                      Upload an image of the logo. (Not larger than 2MB)
                    </Text>

                    <input
                      accept="image/*"
                      type="file"
                      name="certificateFile"
                      ref={inputRef}
                      onChange={(e) => handleFileChange(e)}
                      style={{ display: "none" }}
                    ></input>
                    <Input
                      cursor="pointer"
                      placeholder="No file selected"
                      defaultValue={filename}
                      mt="10px"
                      borderColor="#eeeeee"
                      fontSize={14}
                      bg="#fafafa"
                      onClick={() => inputRef?.current?.click()}
                      border="2px dashed"
                      borderRadius={2}
                    />
                  </FormControl>
                  <Flex mt={12} justifyContent="end">
                    <HStack>
                      <Button
                        size="sm"
                        px={6}
                        fontSize={12}
                        ref={cancelRef}
                        onClick={() => onClosed()}
                      >
                        Cancel
                      </Button>
                      <Button
                        colorScheme="red"
                        type="submit"
                        isLoading={formik.isSubmitting}
                        size="sm"
                        px={6}
                        fontSize={12}
                      >
                        {" "}
                        Save
                      </Button>
                    </HStack>
                  </Flex>
                </form>
              )}
            </Box>
          </ModalBody>

          <ModalFooter></ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};
